import httpClient from '@/app/utils/axios';
import { Result } from '@/app/api/models/baseModel';
import { Classroom } from '@/app/api/models/classroom';
import { Module } from '@/app/api/models/module';
import { Session } from '@/app/api/models/session';
import { BaseModuleState } from '@/app/services/modules/BaseModuleService';
import { SessionModeEnum } from '@/enums/SessionModeEnum';
import { SessionModule } from './models/sessionModule';
import { isTeacher } from '@/app/helpers/userHelper';

export interface ClassroomSession {
    session: Session;
    state: BaseModuleState;
    student_states: {
        [studentId: number]: unknown;
    };
    session_students: {
        [studentId: number]: string;
    };
    module: Module;
}

export function getClassroomSession(classroom: Classroom) {
    const routeName = isTeacher() ? 'app.teacher.active-session' : 'app.active-session';
    return httpClient.get<Result<ClassroomSession>>(route(routeName, classroom));
}

export function storeClassroomSession(classroom: Classroom) {
    return httpClient.post<Result<ClassroomSession>>(route('app.session.store', classroom));
}

export function updateClassroomSession<T = unknown>(classroom: Classroom, module: Module, event: string, data?: T) {
    return httpClient.put<Result<T>>(route('app.session.update', classroom), {
        module_id: module.id,
        event,
        data,
    });
}

export function sessionModuleResult<T = unknown>(session: Session, batchId: string, studentId?: number) {
    return httpClient.get<
        Result<{
            result: T;
            module: Module;
        }>
    >(route('app.session.module-result', [session, batchId, studentId]));
}

export function startSession(classroom: Classroom, mode: SessionModeEnum) {
    return httpClient.post<
        Result<{
            session: Session;
        }>
    >(route('app.teacher.session.store', classroom), {
        mode,
    });
}

export function doneSession(classroom: Classroom) {
    return httpClient.put<Result<ClassroomSession>>(route('app.teacher.session.done', classroom));
}

// 별 지급
export function storeClassroomSessionStars(
    session: Session,
    moduleId: number | null,
    studentIds: number[],
    comment: string | null,
) {
    return httpClient.post<Result>(route('app.teacher.session-stars.store'), {
        session_id: session.id,
        session_module_id: moduleId,
        selected_student_ids: studentIds,
        comment,
    });
}

export function putSessionToggleFocusScreen(classroom: Classroom) {
    return httpClient.put<Result<{ is_focus_screen: boolean }>>(
        route('app.teacher.session.toggle-focus-screen', classroom),
    );
}

/**
 * 수업 활동 목록 조회
 */
export function getSessionModules(session: Session) {
    return httpClient.get<Result<{ session_modules: SessionModule[] }>>(
        route('app.teacher.session.session-modules', session),
    );
}
